<div class="flex-column flex-overflow-initial gap">
    @if (tasks()) {
        @for (task of tasks()!.items(); track task.id) {
            <app-user-task-item [item]="task"></app-user-task-item>
        }

        @if (tasks()!.isEmpty() && !tasks()!.loading()) {
            <app-empty-state></app-empty-state>
        }

        <app-infinite-scroll-load-on-screen
            class="align-self-center"
            [infiniteScroll]="tasks()"
        ></app-infinite-scroll-load-on-screen>
    }
</div>
